<template>
    <div class="qStem">
        <p v-html="question.question_description" class="qDescript"></p>
        <!-- <p>完型填空 说明</p> -->
        <!-- <b v-if="question.is_objective==0&&moduleId==124" title="该题为主观题，需要您手动批改" class="correctHand">批</b> -->
        <div class="mt-20">
            <span v-if="question.sid>-1&&moduleId!=15" class="queNum">{{question.sid +1}}. </span>
            <span v-if="question.question_ref_sorce">({{question.question_ref_sorce || 0}}分, {{question.difficultyDegree}}难度)</span>
        </div>
        <div class="qStemC">
            <div v-html="fillFormatHtml(question.stem)" class="qsamllStem"> </div>
            <attachments  :attachments="question.attachments"  :playerObj="playerObj"  @playedObj="playedObj" :id="question.id"></attachments>
            <tabTopic :infoAnswer='question.ref_info && question.ref_info.answers[0]' :knowledgePoints="question.knowledge_points" :skillPoints="question.skill_points"
                :explains="question.explains" :tags="question.tags" :qtype="4" :isObject='true' v-if="moduleId==124"></tabTopic>
            <div class="m-t20" v-for="(question, index) in question.children">
                <singleChoice   v-if="question.qtype==1"      :question="question"   :playerObj="playerObj"    @playedObj="playedObj"  :moduleId="moduleId" :parentqtype="question.qtype" :isShowAnswer="isShowAnswer"></singleChoice>
                <filling        v-else-if="question.qtype==3" :question="question"   :playerObj="playerObj"    @playedObj="playedObj"  @correctScore="correctScore"  :moduleId="moduleId" :parentqtype="question.qtype" :isShowAnswer="isShowAnswer"></filling>
                <shortanswer    v-else-if="question.qtype==6" :question="question" :underlineF='true'  :id="question.id+index" :playerObj="playerObj"    @playedObj="playedObj"  :moduleId="moduleId" :parentqtype="question.qtype" :isShowAnswer="isShowAnswer"></shortanswer>
                <imitation      v-else-if="question.qtype==7" :question="question"   :playerObj="playerObj"    @playedObj="playedObj"  :moduleId="moduleId" :parentqtype="question.qtype" :isShowAnswer="isShowAnswer"></imitation>
            </div>
        </div>
    </div>
</template>

<script>
    // 阅读理解,该题型包含小题，小题类型有：1单选图、6简答题、7模仿朗读
    import tabTopic from './tabTopic.vue' // 附件
    import listenTabTopic from './listenTabTopic.vue' // 听说的tab
    import attachments from './attachments.vue'         // 附件
    import singleChoice from './singleChoice.vue'       // 1单选题
    import filling from './filling.vue'                 // 3填空题
    import shortanswer from './shortanswer.vue'         // 6简答题
    import imitation from './imitation.vue'             // 7模仿朗读or简答题
   
    export default {
        data(){
            return {
            }
        },
        props:[
            'page',
            'moduleId', 
            'question',
            'isShowAnswer',
            'playerObj',
            'qtype'
        ],
        components:{
            attachments,
            singleChoice,
            filling,
            shortanswer,
            imitation,
            tabTopic,
            listenTabTopic
        },
        mounted(){  // 同v1.*的ready
         
        },
        computed:{
            // debugger;
        },
        methods:{
            // 格式化填空
            fillFormatHtml(val){
                let data = val
                if (this.qtype == 9) {
                   data = data.replace(/\s+style="[^"]*"/g, '')
                }
                return data.replace(/{#blank#}(\d*){#\/blank#}/g,'<span class="filling-txt"><i class="filling_bg">$1</i></span>')
                
            },
            playedObj(playerObj){
                this.$emit('playedObj', playerObj)
            },
            correctScore(correctScore){
                this.$emit('correctScore',correctScore);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// allFilling.vue?f85b0d44